// extracted by mini-css-extract-plugin
export default {"container":"KY7nY5","borderMargin":"On8vi3","repositionCoverButton":"cAShnz","coverIsMoving":"UM1fRL"};